document.addEventListener('DOMContentLoaded', function () {
  const targets = document.querySelectorAll('.sg-block');

  const observer = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '0px 0px -100px 0px'
  });

  targets.forEach(function (el) {
    observer.observe(el);
  });
});
